import React, { useState, useEffect } from 'react';
import {
  ShoppingBagIcon,
  CreditCardIcon,
  UserGroupIcon,
  BoltIcon
} from '@heroicons/react/24/outline';
import socketService from '../services/socket';

function LiveStats() {
  const [stats, setStats] = useState({
    totalCookies: 0,
    activeCookies: 0,
    totalCards: 0,
    connectedUsers: 0,
    timestamp: null
  });

  useEffect(() => {
    socketService.on('live-stats', (data) => {
      setStats(data);
    });

    socketService.requestLiveStats();

    return () => {
      socketService.off('live-stats');
    };
  }, []);

  return (
    <div style={{
      background: '#111111',
      border: '1px solid #222222',
      borderRadius: '1rem',
      padding: '1rem',
      marginBottom: '1rem'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
        <BoltIcon style={{ width: '1.25rem', height: '1.25rem', color: '#00ffff' }} />
        <h4 style={{ color: '#ffffff', fontWeight: '600' }}>Estadísticas en Vivo</h4>
        {stats.timestamp && (
          <span style={{
            marginLeft: 'auto',
            fontSize: '0.7rem',
            color: '#9ca3af'
          }}>
            {new Date(stats.timestamp).toLocaleTimeString()}
          </span>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem' }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
            <ShoppingBagIcon style={{ width: '1rem', height: '1rem', color: '#00ffff' }} />
            <span style={{ color: '#9ca3af', fontSize: '0.75rem' }}>Cookies</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.5rem' }}>
            <span style={{ color: '#ffffff', fontSize: '1.5rem', fontWeight: 'bold' }}>{stats.totalCookies}</span>
            <span style={{ color: '#ccff00', fontSize: '0.875rem' }}>({stats.activeCookies} activas)</span>
          </div>
        </div>

        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
            <CreditCardIcon style={{ width: '1rem', height: '1rem', color: '#ff00ff' }} />
            <span style={{ color: '#9ca3af', fontSize: '0.75rem' }}>Tarjetas</span>
          </div>
          <div style={{ color: '#ffffff', fontSize: '1.5rem', fontWeight: 'bold' }}>{stats.totalCards}</div>
        </div>

        <div style={{ gridColumn: 'span 2' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
            <UserGroupIcon style={{ width: '1rem', height: '1rem', color: '#ff6600' }} />
            <span style={{ color: '#9ca3af', fontSize: '0.75rem' }}>Usuarios Conectados</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <div style={{
              width: '0.5rem',
              height: '0.5rem',
              borderRadius: '50%',
              background: '#ccff00',
              boxShadow: '0 0 10px #ccff00'
            }}></div>
            <span style={{ color: '#ffffff', fontSize: '1.25rem', fontWeight: 'bold' }}>{stats.connectedUsers}</span>
            <span style={{ color: '#9ca3af', fontSize: '0.75rem' }}>en línea</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LiveStats;